import React, { useEffect, useState } from "react";
import { Route, Routes as ReactRoutes } from "react-router-dom";
import Index from "./Partials/Universal/Dashboard/Index";
import RoomBooking from "./Partials/Universal/Hotels/Components/RoomBooking/RoomBooking";
import RoomFacilitesList from "./Partials/Universal/Hotels/Components/RoomFacilitesList/RoomFacilitesList";
import HouseKeepingAssignRoom from "./Partials/Universal/Hotels/Components/HouseKeepingAssignRoom/HouseKeepingAssignRoom";
import ItemsList from "./Partials/Universal/Hotels/Components/ItemsList/ItemsList";
import BookingReport from "./Partials/Universal/Hotels/Components/BookingReport/BookingReport";
import Transaction from "./Partials/Universal/Transaction/Transaction";
import RoomCheckout from "./Partials/Universal/RoomBook/Components/RoomCheckout/RoomCheckout";
import RoomStatus from "./Partials/Universal/RoomBook/Components/RoomStatus/RoomStatus";
import ItemsUnitList from "./Partials/Universal/ItemsManage/Components/ItemsUnitList/ItemsUnitList";
import ItemsSuppliers from "./Partials/Universal/ItemsManage/Components/ItemsSuppliers/ItemsSuppliers";
import StockReport from "./Partials/Reports/Components/StockReport/StockReport";
import BookingTypeList from "./Partials/RoomsSettings/Components/BookingTypeList/BookingTypeList";
import RoomList from "./Partials/RoomsSettings/Components/RoomList/RoomList";
import RoomTypes from "./Partials/Universal/RoomBook/Components/RoomType/RoomTypes";
import Seasonals from "./Partials/Universal/RoomBook/Components/Seasonals/Offers";
import Packages from "./Partials/Universal/RoomBook/Components/RoomPackages/Packages";
import FrontDeskDashboard from "./Partials/Universal/FrontDesk/FrontDeskDashboard";
import ReservationList from "./Partials/RoomsSettings/Components/RoomReservation/ReservationList";
import AddRoomBooking from "./Partials/RoomsSettings/Components/RoomReservation/Components/AddRoomBooking";
import CheckOutBookingDetails from "./Partials/RoomsSettings/Components/RoomReservation/CheckOut/CheckOutBooking";
import BookingLogsList from "./Partials/RoomsSettings/Components/BookingLogs/BookingLogsList";
import PaymentInvoice from "./Partials/RoomsSettings/Components/RoomReservation/CheckOut/PaymentInvoice";
import RestaurantCategoryList from "./Partials/RoomsSettings/Components/Restaurant/RestaurantCategoryList";
import TableList from "./Partials/RoomsSettings/Components/RestaurantTables/TableList";
import RestaurantSubCategoryList from "./Partials/RoomsSettings/Components/Restaurant/RestaurantSubCategoryList";
import ReservationVariantList from "./Partials/RoomsSettings/Components/Restaurant/RestaurantVariantList";
import Order from "./Partials/RoomsSettings/Components/RestaurantTables/Order";
import CreateOrder from "./Partials/RoomsSettings/Components/RestaurantTables/CreateOrder";

import Departments from "./Partials/Universal/ItemsManage/Components/Departments/Departments";
import DepartmentsCategory from "./Partials/Universal/ItemsManage/Components/Departments/DepartmentsCategory";
import DepartmentsInventory from "./Partials/Universal/ItemsManage/Components/Departments/DepartmentsInventory";
import CreateUser from "./components/Auth/CreateUser";
import Procurements from "./Partials/Universal/ItemsManage/Components/Procurement/Procurements";
import ReportsMainList from "./Partials/RoomsSettings/Components/AllReports/ReportsMainList";
import CreateProcurement from "./Partials/Universal/ItemsManage/Components/Procurement/CreateProcurements";
import ProcurementItemsList from "./Partials/Universal/ItemsManage/Components/Procurement/ProcumentItemsListPage";
import ManageAccess from "./Partials/Universal/Settings/ManageAccess/ManageAccess";
import ManageUserAccess from "./Partials/Universal/Settings/UserAccess/ManageUserAccess";
import { useSelector } from "react-redux";
import { hasViewAccess } from "./Common/CheckAccess";
import UnauthorizedPage from "./Tuning/Pages/Authentication/unauthorizedPage";
import AssignedEmployeeList from "./Partials/AssignedEmployeeList/AssignedEmployeeList";
import NoPageFound from "./Tuning/Pages/Authentication/NoPageFound";
import Amenity from "./Partials/Universal/RoomBook/Components/Amenities/Amenity";
import Dashboard from "./Partials/Universal/Settings/NightAudit/Dashboard";
import CreateHotelAdmin from "./components/Auth/CreateHotelAdmin";
import BudgetManager from "./Partials/Universal/Settings/Budget/BudgetManager";
import CustomExpenseManager from "./Partials/Universal/Settings/Budget/CustomExpenseManager";
import RestaurantSettingsManager from "./Partials/Universal/Settings/Budget/RestaurantSettingsManager";
import ManageHotel from "./components/Auth/ManageHotel";

const routesConfig = [
  // Dashboard
  { path: "/", element: <Index />, resource: "dashboard" },
  { path: "/index", element: <Index />, resource: "dashboard" },

  // Reservation
  {
    path: "/reservation/booking-list",
    element: <ReservationList />,
    resource: "reservation",
  },
  {
    path: "/reservation/booking-logs",
    element: <BookingLogsList />,
    resource: "reservation",
  },
  {
    path: "/reservation/add-room-booking",
    element: <AddRoomBooking />,
    resource: "reservation",
  },
  {
    path: "/reservation/add-room-booking/:id",
    element: <AddRoomBooking />,
    resource: "reservation",
  },
  {
    path: "/reservation/check-out-booking/:reservation_id",
    element: <CheckOutBookingDetails />,
    resource: "reservation",
  },
  {
    path: "/reservation/invoice",
    element: <PaymentInvoice />,
    resource: "reservation",
  },
  {
    path: "/reports",
    element: <ReportsMainList />,
    resource: "reports",
  },
  {
    path: "/reservations/booking-report",
    element: <BookingReport />,
    resource: "reports",
  },

  // Front Desk
  {
    path: "/front-desk/user/:userId",
    element: <RoomBooking />,
    resource: "front_desk",
  },
  {
    path: "/front-desk/room-facilites-list",
    element: <RoomFacilitesList />,
    resource: "front_desk",
  },
  {
    path: "/front-desk/checkin-out",
    element: <RoomCheckout />,
    resource: "front_desk",
  },
  {
    path: "/front-desk/transaction",
    element: <Transaction />,
    resource: "front_desk",
  },
  {
    path: "/front-desk/dashboard",
    element: <FrontDeskDashboard />,
    resource: "front_desk",
  },
  {
    path: "/front-desk/guest-management",
    element: <AssignedEmployeeList />,
    resource: "front_desk",
  },
  {
    path: "/front-desk/guest-management/add",
    element: <RoomBooking />,
    resource: "front_desk",
  },

  // Inventory
  {
    path: "/inventory/items-list",
    element: <ItemsList />,
    resource: "inventory",
  },
  {
    path: "/inventory/items-unit-list",
    element: <ItemsUnitList />,
    resource: "inventory",
  },
  // { path: "/inventory/items-category-list", element: <ItemsCategory />, resource: "inventory" },
  {
    path: "/inventory/items-suppliers-list",
    element: <ItemsSuppliers />,
    resource: "inventory",
  },
  {
    path: "/inventory/stock-report",
    element: <StockReport />,
    resource: "inventory",
  },

  // Rooms
  {
    path: "/rooms/update-status",
    element: <HouseKeepingAssignRoom />,
    resource: "rooms",
  },
  { path: "/rooms/status", element: <RoomStatus />, resource: "rooms" },
  { path: "/rooms/types", element: <RoomTypes />, resource: "rooms" },
  { path: "/rooms/offers", element: <Seasonals />, resource: "rooms" },
  { path: "/rooms/packages", element: <Packages />, resource: "rooms" },
  { path: "/rooms/room-list", element: <RoomList />, resource: "rooms" },
  { path: "/rooms", element: <RoomList />, resource: "rooms" },
  {
    path: "/rooms/booking-type-list",
    element: <BookingTypeList />,
    resource: "rooms",
  },
  {
    path: "/rooms/amenity",
    element: <Amenity />,
    resource: "rooms",
  },

  // Restaurant
  {
    path: "/restaurant/table-list",
    element: <TableList />,
    resource: "restaurant",
  },
  {
    path: "/restaurant/table-reservation",
    element: <PaymentInvoice />,
    resource: "restaurant",
  },
  {
    path: "/restaurant/category",
    element: <RestaurantCategoryList />,
    resource: "restaurant",
  },
  {
    path: "/restaurant/category/:categoryId",
    element: <RestaurantSubCategoryList />,
    resource: "restaurant",
  },
  {
    path: "/restaurant/:categoryId/subCategory/:subCategoryId",
    element: <ReservationVariantList />,
    resource: "restaurant",
  },
  { path: "/restaurant/order", element: <Order />, resource: "restaurant" },
  {
    path: "/restaurant/add-order",
    element: <CreateOrder />,
    resource: "restaurant",
  },
  {
    path: "/restaurant/edit-order/:id",
    element: <CreateOrder />,
    resource: "restaurant",
  },

  // Departments
  { path: "/departments", element: <Departments />, resource: "inventory" },
  {
    path: "/department/category/:categoryId",
    element: <DepartmentsCategory />,
    resource: "inventory",
  },
  {
    path: "/department/category/:categoryId/:subCategoryId",
    element: <DepartmentsInventory />,
    resource: "inventory",
  },

  // User Management
  {
    path: "/settings/create-user",
    element: <CreateUser />,
    resource: "setting",
  },
  {
    path: "/settings/budget",
    element: <BudgetManager />,
    resource: "setting",
  },
  {
    path: "/settings/custom-expense",
    element: <CustomExpenseManager />,
    resource: "setting",
  },
  {
    path: "/settings/restaurant-room-config",
    element: <RestaurantSettingsManager />,
    resource: "setting",
  },

  // Procurements
  { path: "/procurements", element: <Procurements />, resource: "procurement" },
  {
    path: "/procurements/create-procurement",
    element: <CreateProcurement />,
    resource: "procurement",
  },
  {
    path: "/procurements/:procurement_request_id",
    element: <ProcurementItemsList />,
    resource: "procurement",
  },
  {
    path: "/procurement-edit/:id",
    element: <CreateProcurement />,
    resource: "procurement",
  },
  {
    path: "/settings/manageAccess",
    element: <ManageAccess />,
    resource: "setting",
  },
  {
    path: "/settings/manageAccess/:id",
    element: <ManageUserAccess />,
    resource: "setting",
  },
  {
    path: "/settings/night-audit",
    element: <Dashboard />,
    resource: "setting",
  },

  {
    path: "/create-admin",
    element: <CreateHotelAdmin />,
    resource: "create_admin",
  },
  {
    path: "/manage-hotels",
    element: <ManageHotel />,
    resource: "create_admin",
  },
  
];

const Routes = () => {
  const { userAccess } = useSelector((state) => state.settings);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const existingPermissions = localStorage.getItem("checkPermission");

    if (existingPermissions) {
      const parsedPermissions = JSON.parse(existingPermissions);
      setPermissions(parsedPermissions);
    } else
     if (userAccess?.data?.permissions?.length > 0) {
      localStorage.setItem(
        "checkPermission",
        JSON.stringify(userAccess.data.permissions)
      );
      setPermissions(userAccess.data.permissions);
    }
  }, [userAccess]);

  const accessibleRoutes = routesConfig.filter((route) =>
    hasViewAccess(
      JSON.parse(localStorage.getItem("checkPermission") || "[]"),
      route.resource
    )
  );


  return (
    // <ReactRoutes>
    //   {accessibleRoutes.map((route, idx) => (
    //     <Route key={idx} path={route.path} element={route.element} />
    //   ))}
    //   <Route path="*" element={<UnauthorizedPage/>} />
    // </ReactRoutes>
    <ReactRoutes>
      {routesConfig.map((route, idx) => {
        const hasAccess = hasViewAccess(permissions, route.resource);
        console.log("hasAccess",hasAccess)
        return (
          <Route
            key={idx}
            path={route.path}
            element={hasAccess ? route.element : <UnauthorizedPage />}
          />
        );
      })}
      <Route path="*" element={<NoPageFound />} />
    </ReactRoutes>

  );
};

export default Routes;
